// Web 版で使用するサンプル データです。

// hc-power-11.col + hc-power-11_01.dat を結合したデータです。
export const sample1 = `p 21 28
e 1 2
e 2 3
e 3 4
e 4 5
e 5 6
e 1 7
e 6 8
e 1 9
e 7 10
e 7 11
e 8 12
e 8 13
e 9 14
e 9 15
e 10 11
e 12 13
e 14 15
e 10 16
e 11 17
e 12 18
e 13 19
e 14 20
e 15 21
e 16 17
e 17 18
e 18 19
e 19 20
e 20 21
s 1 3 5 11 13 15 16 18 20
t 1 3 5 10 12 14 17 19 21
`;
